import React from "react"
import "./index.scss"
import { CrossSellingRankingContainer } from "./CrossSellingRanking/components/CrossSellingRankingContainer"
import { CrossSellingSubHeader } from "./CrossSellingRanking/components/CrossSellingSubHeader/index"
import { useFiltersContext } from "components/Shared/GlobalFilter/context/filtersContext"
import useConfirmedFilters from "components/Shared/Filters/hooks/useConfirmedFilters"
import { mapModuleFilters } from "components/Shared/Filters/utils"
import { FiltersRequestButton } from "components/Shared/Filters/FiltersRequestButton"
import { SinglePeriod } from "components/Labs/CrossSelling/interfaces"
import { useGetErrorFilters } from "components/Shared/Filters/hooks/useGetErrorFilters"
import { useSetVendorFilters } from "components/CustomerBehavior/Switching/SwitchingBreakdown/hooks"
import { CrossSellingInputValidator } from "./CrossSellingRanking/components/CrossSellingFilterValidator"
import mandatoryFilters from "./CrossSellingRanking/components/CrossSellingFilterValidator/CrossSellingValidatorConfig"
import useGetModuleByPath from "components/Shared/Hooks/useGetModuleByPath/useGetModuleByPath"

const CrossSelling: React.FC = () => {
	useSetVendorFilters()
	const { filters } = useFiltersContext()
	const [calendarDates, setCalendarDates] = React.useState<SinglePeriod>(
		{} as SinglePeriod
	)
	const newModuleConfig = useGetModuleByPath()
	const {
		confirmedFilters: crossSellingFilters,
		calendarDateConfirmed,
		confirmFilters,
		hasFilterChangesSinceLastUpdate,
	} = useConfirmedFilters<SinglePeriod>(filters, calendarDates)
	const mappedConfirmedFilters = mapModuleFilters({
		filters: crossSellingFilters,
		calendarDates: calendarDateConfirmed,
	})

	const requestSwitchingReports = () => {
		confirmFilters()
	}

	const isValidFilters = !useGetErrorFilters(
		filters,
		calendarDates,
		mandatoryFilters
	)

	const isButtonRequestEnabled =
		isValidFilters && hasFilterChangesSinceLastUpdate

	return (
		<div
			className="cross-selling-ranking-container"
			data-testid="cross-selling-ranking-container"
		>
			<CrossSellingSubHeader
				onChangeCalendar={(dates) => {
					setCalendarDates(dates)
				}}
				newModuleConfig={newModuleConfig}
			/>
			<FiltersRequestButton
				onClick={requestSwitchingReports}
				disabled={!isButtonRequestEnabled}
				UNSAFE_className="cross_selling_button_requester"
			/>
			<CrossSellingInputValidator filters={mappedConfirmedFilters}>
				<CrossSellingRankingContainer filters={mappedConfirmedFilters} />
			</CrossSellingInputValidator>
		</div>
	)
}

export default CrossSelling
